import { render } from "./DeleteInformationPartCard.vue?vue&type=template&id=ae947150"
import script from "./DeleteInformationPartCard.vue?vue&type=script&lang=js"
export * from "./DeleteInformationPartCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__